import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { Subprovider } from '@bitski/provider-engine';
/**
 * A subprovider that tracks and automatically increments the nonce on the client.
 * Heavily based on the provider-engine NonceTrackerSubprovider, but modified for
 * Bitski's transaction flow.
 */

export var NonceTrackerSubprovider = /*#__PURE__*/function (_Subprovider) {
  _inherits(NonceTrackerSubprovider, _Subprovider);

  var _super = _createSuper(NonceTrackerSubprovider);

  function NonceTrackerSubprovider() {
    var _this;

    _classCallCheck(this, NonceTrackerSubprovider);

    _this = _super.call(this);
    _this.nonceCache = new Map();
    return _this;
  }

  _createClass(NonceTrackerSubprovider, [{
    key: "handleRequest",
    value: function handleRequest(payload, next, end) {
      switch (payload.method) {
        case 'eth_getTransactionCount':
          this.handleTransactionCountRequest(payload, next, end);
          return;

        case 'eth_sendTransaction':
          this.handleSendTransactionRequest(payload, next);
          return;

        default:
          next();
          return;
      }
    } // Return cached result if present

  }, {
    key: "handleTransactionCountRequest",
    value: function handleTransactionCountRequest(payload, next, end) {
      var _this2 = this;

      var blockTag = payload.params.length > 1 ? payload.params[1] : null; // Only handle pending tag

      if (blockTag !== 'pending') {
        next();
        return;
      }

      var address = payload.params[0].toLowerCase();
      var cachedResult = this.nonceCache.get(address); // Return cached result it we have it

      if (cachedResult) {
        end(null, cachedResult);
        return;
      } // Fallthrough and populate cache


      next(function (err, result, cb) {
        if (!err) {
          _this2.nonceCache.set(address, result);
        }

        cb();
      });
    }
  }, {
    key: "toHex",
    value: function toHex(num) {
      var base16 = num.toString(16);
      var hex = base16;

      if (base16.length % 2 !== 0) {
        hex = '0' + base16;
      }

      return '0x' + hex;
    }
  }, {
    key: "fromHex",
    value: function fromHex(str) {
      return parseInt(str, 16);
    }
  }, {
    key: "nextNonce",
    value: function nextNonce(nonce) {
      var submittedNonce = this.fromHex(nonce);
      var nextNonce = submittedNonce + 1;
      return this.toHex(nextNonce);
    } // Increment next nonce for address

  }, {
    key: "handleSendTransactionRequest",
    value: function handleSendTransactionRequest(payload, next) {
      var _this3 = this;

      // Submit the request, then monitor the result
      next(function (err, result, cb) {
        var transaction = payload.params.length > 0 ? payload.params[0] : {};
        var submittedNonce = transaction.nonce;
        var address = transaction.from;

        if (!err) {
          if (submittedNonce && address) {
            // Increment nonce
            var nextNonce = _this3.nextNonce(submittedNonce);

            _this3.nonceCache.set(address, nextNonce);
          }
        } else {
          // Remove cached value if we encounter an error
          _this3.nonceCache.delete(address);
        }

        cb();
      });
    }
  }]);

  return NonceTrackerSubprovider;
}(Subprovider);